import { render, staticRenderFns } from "./MainPageRunningHourNew.vue?vue&type=template&id=67604b02&scoped=true"
import script from "./MainPageRunningHourNew.vue?vue&type=script&lang=js"
export * from "./MainPageRunningHourNew.vue?vue&type=script&lang=js"
import style0 from "./MainPageRunningHourNew.vue?vue&type=style&index=0&id=67604b02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67604b02",
  null
  
)

export default component.exports